import React, { useRef } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import Select, { components } from 'react-select';
import PropTypes from 'prop-types';
import { Field } from '@snsw-gel/react';
import { multiSelectStylesGel3, multiSelectThemeGel3 } from './MultiSelectField.styled';

/** @type {React.FC<Record<string, any>>} */
export const MultiSelectField = ({
  name,
  label,
  options,
  helpMessage,
  placeHolder,
  isMulti = true,
  rules,
  id,
  ...props
}) => {
  const labelId = id ?? name + '-label';
  const descriptionId = name + '-description';
  const {
    control,
    formState: { errors: formErrors },
    clearErrors,
  } = useFormContext();
  const selectedOptions = useWatch({ control, name });
  const errors = formErrors[name];
  const selectRef = useRef();
  const styles = multiSelectStylesGel3(errors);
  const theme = multiSelectThemeGel3;

  // useEffect(() => {
  //   if (errors && errors.message) {
  //     analyticsUtil.pushAlertAnalytics({
  //       type: 'alert error',
  //       name: 'in-page alert',
  //       text: errors.message,
  //       errorPos: 'page content',
  //     });
  //   }
  // }, [errors]);

  const Input = (props) => {
    return <components.Input {...props} aria-required={true} aria-describedby={descriptionId} />;
  };

  return (
    <>
      <Field
        label={label}
        id={labelId}
        hasError={!!errors?.message}
        errorMessage={errors?.message}
        helpMessage={helpMessage}
      >
        <Controller
          name={name}
          control={control}
          defaultValue={selectedOptions}
          render={({ field: { onChange } }) => {
            return (
              <Select
                ref={selectRef}
                inputId={labelId}
                aria-invalid={!!errors}
                isMulti={isMulti}
                value={selectedOptions}
                options={options}
                components={{ Input }}
                placeholder={placeHolder || 'Select options...'}
                onChange={(newValue) => {
                  const getIndexOfOption = (val) => options.map((opt) => opt.value).indexOf(val) + 1;

                  // analyticsUtil.pushComponentAnalytics({
                  //   type: 'drop_down_list_selection',
                  //   category: innerText(label).toLowerCase(),
                  //   text: isMulti ? newValue.map((opt) => opt.value.toString()).join('|') : newValue.value.toString(),
                  //   sectionId: 'page_content',
                  //   positionId: isMulti
                  //     ? newValue.map((opt) => getIndexOfOption(opt.value)).join('|')
                  //     : getIndexOfOption(newValue).toString(),
                  // });

                  clearErrors(name);
                  onChange(newValue);
                  setTimeout(() => selectRef.current?.inputRef.focus(), 50);
                }}
                styles={styles}
                theme={theme}
                {...props}
              />
            );
          }}
          rules={rules}
        />
      </Field>
    </>
  );
};

const reactSelectOption = PropTypes.shape({
  value: PropTypes.string,
  label: PropTypes.string,
});

MultiSelectField.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  options: PropTypes.arrayOf(reactSelectOption).isRequired,
  helpMessage: PropTypes.string,
  placeHolder: PropTypes.string,
  isMulti: PropTypes.bool,
  rules: PropTypes.object,
};
